import { Card, CardContent } from '@/components/ui/card';
import { Server } from 'lucide-react';
import type { NewSizingSnapshot } from '@/sizing/newSizingEngine';

interface SizingHeroCardProps {
  snapshot: NewSizingSnapshot | null;
  serverCount: number;
  gpuCount: number;
  serverDisplayName?: string;
  acceleratorDisplayName?: string;
}

export const SizingHeroCard = ({ snapshot, serverCount, gpuCount, serverDisplayName = 'XE7740 Servers', acceleratorDisplayName = 'Intel Gaudi 3 Accelerators' }: SizingHeroCardProps) => {
  if (!snapshot) {
    return (
      <Card className="border-border/50">
        <CardContent className="p-8">
          <div className="space-y-4">
            <div className="h-8 w-48 animate-pulse rounded bg-muted" />
            <div className="h-24 animate-pulse rounded bg-muted" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden border-primary/20 shadow-xl shadow-primary/5 bg-gradient-to-br from-card via-primary/5 to-card">
      <CardContent className="p-8">
        <div className="space-y-3">
          <div className="text-sm text-muted-foreground font-medium flex items-center gap-2">
            <Server className="h-4 w-4 text-primary" />
            Infrastructure Needed
          </div>
          
          <div className="flex items-baseline gap-4">
            <span className="text-7xl font-bold bg-gradient-to-br from-primary to-primary/60 bg-clip-text text-transparent drop-shadow-lg">
              {serverCount}
            </span>
            <div className="space-y-1 pb-2">
              <div className="text-7xl font-bold text-foreground">{serverDisplayName}</div>
              <div className="text-sm text-muted-foreground space-y-0.5">
                <div>Intel Xeon CPU</div>
                <div>{acceleratorDisplayName} • {gpuCount} GPUs total</div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
